import { useState } from 'react';
import '../Loginpage/loginpage.style.css';
import loginUser from '../../../utils/login';
import setAuthCookie from '../../../auth/setAuthCookie';

function LoginPage() {
    const [ email, setEmail ] = useState('');
    const [ password, setPassword ] = useState('');

    const submit = async (e) => {
        e.preventDefault();
        const statusLogin = await loginUser(email, password);
        const { data } = statusLogin;
        if (data.message == 'OK') {
            setAuthCookie('token', data.token, 2);
            window.location = `/bartender/profile/admin/id=${data.user._id}`;
        } else {
            console.log('error');
        }
    }




    return(
        <div className="Login-Container">
            <h1>Login</h1>
            <form onSubmit={submit}>
                <input onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Ingrese Email" />
                <input onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Ingrese Password" />
                <button>Entrar</button>
            </form>
        </div>
    )
}

export default LoginPage;